import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'leimma4';
const args = {};

export class Leimma4 extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
